import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import ResumeContentEducation from "./ResumeContentEducation";
import pdf from "../../Assets/mycv.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Senior Software Engineer [Full Stack]"
              date="Dec 2019 - Present"
              content={[
                "Assembled the data from various social media platforms using Twitter, Reddit.Interpreted the collected text using word-clouds and various other factors that affect the change of sentiments of youth.",
                " Utilized the data to find the issues using Topic Modelling and Building models using LSTM, BERT to predict the sentiments of the youth.",
              ]}
            />

            <Resumecontent
              title="Software Engineer [Full Stack]"
              date="July 2018 - Dec 2019"
              content={[
                "Assembled the data from various social media platforms using Twitter, Reddit.Interpreted the collected text using word-clouds and various other factors that affect the change of sentiments of youth.",
                " Utilized the data to find the issues using Topic Modelling and Building models using LSTM, BERT to predict the sentiments of the youth.",
              ]}
            />

            <Resumecontent
              title="Software Engineer [Intern]"
              date="July 2016 - July 2017"
              content={[
                "Sales application for leading jewellery company - Designed and developed merchant android application with both backend and frontend development with database design",
                "Popular news application - Completely revamped the mobile application and improved the overall quality and performance",
                "Leading co-operate internet bank application - Involved development in mobile internet banking android application",
                "Top-tier leasing & finance bank application - Involved development in hybrid mobile internet banking for both android and iOS application",
                "Finance bank application - Involved development in hybrid mobile internet banking for both android and iOS application",
                "Popular entertainment application - Revamped the application and involved in bug fixing process",
              ]}
            />

            {/* <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Web Developer [Pantheon-2019 Technical Fest of BIT Mesra]"
              content={[
                "Worked on creating the frontend-end of the website using Bootstrap, Javascript.",
              ]}
            />
            <Resumecontent
              title="Web Developer [Bitotsav-2020 Technical Fest of BIT Mesra]"
              content={[
                "Operated on developing the frontend end of the website using Bootstrap, Javascript and backend APIs using Node.js",
              ]}
            /> */}
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <ResumeContentEducation
              title="Postgraduate Diploma (PgD) Big Data Analytics"
              subTitle="Robert Gordon University Aberdeen, UK"
              date="Jan 2020 - Jan 2021"
            />
            <ResumeContentEducation
              title="BEng(Hons) Software Engineering"
              subTitle="University of Westminster, UK"
              date="Aug 2014 - Aug 2018"
            />
            <ResumeContentEducation
              title="Primary & Secondary Education"
              subTitle="Royal College, Colombo, Sri Lanka"
              date="Jan 2001 - Aug 2014"
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
